import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/react";

import { Sidebar } from "@/components/sidebar";
import { twMerge } from "@/utils/twMerge";

type Item = {
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  active?: boolean;
};

type Props = {
  items: Item[];
  toggleButtonComponent: React.ReactNode | string;
  className?: string;
  itemsClassName?: string;
};

export function HorizontalDropdown({
  items,
  toggleButtonComponent,
  className,
  itemsClassName,
}: Props) {
  return (
    <Menu>
      <MenuButton className={className}>{toggleButtonComponent}</MenuButton>
      <MenuItems
        anchor={{ to: "bottom start", padding: "10px" }}
        className={twMerge(
          "z-50 flex flex-row p-1.25 rounded-12 bg-document-bg dark:bg-gray-800 shadow-md",
          itemsClassName,
        )}
      >
        {items.map((item) => {
          return (
            <MenuItem key={item.title}>
              <Sidebar.Button
                icon={item.icon}
                aria-label={item.title}
                isActive={item.active}
                className="w-9.5 [&:not(:last-child)]:mr-1"
                onClick={item.onClick}
              />
            </MenuItem>
          );
        })}
      </MenuItems>
    </Menu>
  );
}
